import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_zqgv7epztb: FaireBrandEntity = {
  token: "b_zqgv7epztb",
  type: "brand",
  name: "Nice life",
  avatarUrl:
    "https://cdn.faire.com/fastly/702bfc7ffe7354b3d494b62758d5b23ab91e7da5831480bf37234aaae47147c7.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/88685ce2e4f72192ffd948015d524141727e085266a747af011c280a349e71f8.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/702bfc7ffe7354b3d494b62758d5b23ab91e7da5831480bf37234aaae47147c7.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/88685ce2e4f72192ffd948015d524141727e085266a747af011c280a349e71f8.jpeg",
  location: "detroit, MI, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 19,
  isInsider: true,
  description:
    "Nice Life is all about bringing a touch of whimsical style into the home. I am a small batch screen printing company working out of a small artist studio located in Detroit, MI. Small batch means I'm doing it all ! From designing to preparing screens, to printing and hand curing - I am overseeing the entire handmade process my way and making sure everything meets my standards. I strive to be as eco-friendly and sustainable as possible and am continuing to seek out better ways to do this constantly. ",
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:28:23.781Z",
    importedBy: "entity-db-cli",
  },
};
